import React from 'react';

/*
  Welcome — first-login onboarding page extracted from App.js.
  Props: user, navigateTo, clearFirstLogin, setLegalFirstTime, setLifeFinanceFirstTime
*/
const Welcome = ({ user, navigateTo, clearFirstLogin, setLegalFirstTime, setLifeFinanceFirstTime }) => {
  return (
        <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '64px' }}>
          <div style={{ maxWidth: '720px', width: '100%', margin: '0 auto', padding: '64px 24px' }}>

            <h1 style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 400, color: 'var(--text-primary)', lineHeight: 1.2, margin: '0 0 12px', letterSpacing: '-0.01em' }}>
              Welcome to Axigon AI, {user?.name?.split(' ')[0] || 'there'}.
            </h1>
            <p style={{ fontSize: '16px', color: 'var(--text-secondary)', margin: '0 0 52px', lineHeight: 1.6 }}>
              What do you want to do first?
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                {
                  title: 'Understand my finances',
                  desc: 'Upload a bank statement or salary slip. Get a clear picture of where your money goes.',
                  onClick: async () => {
                    await clearFirstLogin();
                    setLifeFinanceFirstTime(true);
                    navigateTo('life-finance');
                  },
                },
                {
                  title: 'Get legal help',
                  desc: 'Ask anything about GST, contracts, compliance, or Indian business law.',
                  onClick: async () => {
                    await clearFirstLogin();
                    setLegalFirstTime(true);
                    navigateTo('legal-gpt');
                  },
                },
                {
                  title: 'Explore everything',
                  desc: 'Go to your dashboard and see all available tools.',
                  onClick: async () => {
                    await clearFirstLogin();
                    navigateTo(user?.accountType === 'personal' ? 'personal-dashboard' : 'dashboard');
                  },
                },
              ].map(({ title, desc, onClick }) => (
                <button
                  key={title}
                  onClick={onClick}
                  style={{ width: '100%', textAlign: 'left', padding: '24px 28px', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: '10px', cursor: 'pointer', transition: 'border-color 0.2s, background-color 0.2s', fontFamily: 'inherit' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.backgroundColor = 'var(--bg)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.backgroundColor = 'var(--bg-secondary)'; }}
                >
                  <div style={{ fontSize: '15px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px' }}>{title}</div>
                  <div style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.6 }}>{desc}</div>
                </button>
              ))}
            </div>

          </div>
        </section>
  );
};

export default Welcome;
